import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core';
import { FacturaDuplicarResolver } from './factura-duplicar-resolver.service';
import { FacturaPopupComponent } from './factura-popup/factura-popup.component';
import { FacturaResolver } from './factura-resolver.service';
import { FacturaServicioRecibidasComponent } from './factura-servicio-recibidas/factura-servicio-recibidas.component';
import { FacturaServicioComponent } from './factura-servicio/factura-servicio.component';
import { NotadecreditoPopupComponent } from './notadecredito-popup/notadecredito-popup.component';
import { NotadecreditoServicioRecibidasComponent } from './notadecredito-servicio-recibidas/notadecredito-servicio-recibidas.component';
import { NotadecreditoServicioComponent } from './notadecredito-servicio/notadecredito-servicio.component';
import { RetencionServicioComponent } from './retencion-servicio/retencion-servicio.component';
import { RetencionPopupComponent } from './retencion-popup/retencion-popup.component';
import { GuiaRemisionComponent } from './guia-remision/guia-remision.component';
import { ProformaResolver } from './proforma-resolver.service';

const routes: Routes = [
    {
        path: '',
        component: FacturaServicioComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'recibir',
        component: FacturaServicioRecibidasComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'factura',
        component: FacturaPopupComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'factura/:uuid',
        component: FacturaPopupComponent,
        canActivate: [AuthGuard],
        resolve: {
            factura: FacturaResolver
        }
    },
    {
        path: 'proforma/:uuid',
        component: FacturaPopupComponent,
        canActivate: [AuthGuard],
        resolve: {
            factura: ProformaResolver
        }
    },
    {
        path: 'factura/extendido/:uuid',
        component: FacturaPopupComponent,
        canActivate: [AuthGuard],
        resolve: {
            facturaExtendido: FacturaDuplicarResolver
        }
    },
    {
        path: 'notasdecredito',
        component: NotadecreditoServicioComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'notasdecredito/recibir',
        component: NotadecreditoServicioRecibidasComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'notasdecredito/notadecredito',
        component: NotadecreditoPopupComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'notasdecredito/notadecredito/:uuid',
        component: NotadecreditoPopupComponent,
        canActivate: [AuthGuard],
        resolve: {
            factura: FacturaResolver
        }
    },
    {
        path: 'notasdecredito/notadecredito/extendido/:uuid',
        component: NotadecreditoPopupComponent,
        canActivate: [AuthGuard],
        resolve: {
            facturaExtendido: FacturaDuplicarResolver
        }
    },
    {
        path: 'retenciones',
        component: RetencionServicioComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'retenciones/recibir',
        component: NotadecreditoServicioRecibidasComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'retenciones/retencion',
        component: RetencionPopupComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'retenciones/retencion/:uuid',
        component: RetencionPopupComponent,
        canActivate: [AuthGuard],
        resolve: {
            factura: FacturaResolver
        }
    },
    {
        path: 'retenciones/retencion/extendido/:uuid',
        component: RetencionPopupComponent,
        canActivate: [AuthGuard],
        resolve: {
            facturaExtendido: FacturaDuplicarResolver
        }
    },
    {
        path: 'guias-remision',
        component: GuiaRemisionComponent,
        canActivate: [AuthGuard],
    },
//    {
//        path: 'guias-remision/recibir',
//        component: GuiaRemisionRecibidasComponent,
//        canActivate: [AuthGuard],
//    },
//    {
//        path: 'guias-remision/guia-remision',
//        component: GuiaRemisionPopupComponent,
//        canActivate: [AuthGuard],
//    },
//    {
//        path: 'guias-remision/guia-remision/:uuid',
//        component: GuiaRemisionPopupComponent,
//        canActivate: [AuthGuard],
//        resolve: {
//            factura: GuiaRemisionResolver
//        }
//    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FacturasRoutingModule { }